import { Tool } from '../types';
import { icons } from './icons';

export const tools: Tool[] = [
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Format, validate, and beautify JSON data with syntax highlighting',
    category: 'formatter',
    icon: icons.jsonFormatter,
    path: '/tools/json-formatter',
    featured: true,
    tags: ['json', 'format', 'validate', 'beautify']
  },
  {
    id: 'base64-encoder',
    name: 'Base64 Encoder/Decoder',
    description: 'Encode and decode Base64 strings with support for files',
    category: 'encoder',
    icon: icons.base64,
    path: '/tools/base64-encoder',
    featured: true,
    tags: ['base64', 'encode', 'decode', 'file']
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder/Decoder',
    description: 'Encode and decode URL components and query parameters',
    category: 'encoder',
    icon: icons.url,
    path: '/tools/url-encoder',
    tags: ['url', 'encode', 'decode', 'uri']
  },
  {
    id: 'hash-generator',
    name: 'Hash Generator',
    description: 'Generate MD5, SHA1, SHA256, SHA512 hashes from text',
    category: 'generator',
    icon: icons.hash,
    path: '/tools/hash-generator',
    featured: true,
    tags: ['hash', 'md5', 'sha1', 'sha256', 'security']
  },
  {
    id: 'uuid-generator',
    name: 'UUID Generator',
    description: 'Generate UUID v1, v4, and v5 with bulk generation options',
    category: 'generator',
    icon: icons.uuid,
    path: '/tools/uuid-generator',
    tags: ['uuid', 'generate', 'unique', 'identifier']
  },
  {
    id: 'password-generator',
    name: 'Password Generator',
    description: 'Generate secure passwords with customizable options',
    category: 'generator',
    icon: icons.password,
    path: '/tools/password-generator',
    tags: ['password', 'secure', 'generate', 'random']
  },
  {
    id: 'jwt-decoder',
    name: 'JWT Decoder',
    description: 'Decode and verify JSON Web Tokens (JWT)',
    category: 'decoder',
    icon: icons.jwt,
    path: '/tools/jwt-decoder',
    featured: true,
    tags: ['jwt', 'token', 'decode', 'verify']
  },
  {
    id: 'qr-generator',
    name: 'QR Code Generator',
    description: 'Generate QR codes for text, URLs, and other data',
    category: 'generator',
    icon: icons.qrCode,
    path: '/tools/qr-generator',
    tags: ['qr', 'code', 'generate', 'url']
  },
  {
    id: 'color-picker',
    name: 'Color Picker',
    description: 'Pick colors and convert between HEX, RGB, HSL formats',
    category: 'color',
    icon: icons.colorPicker,
    path: '/tools/color-picker',
    tags: ['color', 'picker', 'hex', 'rgb', 'hsl']
  },
  {
    id: 'gradient-generator',
    name: 'Gradient Generator',
    description: 'Create beautiful CSS gradients with live preview',
    category: 'color',
    icon: icons.gradient,
    path: '/tools/gradient-generator',
    tags: ['gradient', 'css', 'color', 'design']
  },
  {
    id: 'regex-tester',
    name: 'Regex Tester',
    description: 'Test regular expressions with match highlighting',
    category: 'validator',
    icon: icons.regex,
    path: '/tools/regex-tester',
    tags: ['regex', 'test', 'pattern', 'match']
  },
  {
    id: 'html-encoder',
    name: 'HTML Entity Encoder',
    description: 'Encode and decode HTML entities and special characters',
    category: 'encoder',
    icon: icons.htmlEntity,
    path: '/tools/html-encoder',
    tags: ['html', 'entity', 'encode', 'decode']
  },
  {
    id: 'case-converter',
    name: 'Case Converter',
    description: 'Convert text between different cases: camelCase, snake_case, etc.',
    category: 'text',
    icon: icons.caseConverter,
    path: '/tools/case-converter',
    tags: ['case', 'convert', 'camel', 'snake', 'kebab']
  },
  {
    id: 'word-counter',
    name: 'Word Counter',
    description: 'Count words, characters, paragraphs, and reading time',
    category: 'text',
    icon: icons.wordCounter,
    path: '/tools/word-counter',
    tags: ['word', 'count', 'character', 'text', 'analysis']
  },
  {
    id: 'text-diff',
    name: 'Text Diff',
    description: 'Compare two texts and highlight differences',
    category: 'text',
    icon: icons.textDiff,
    path: '/tools/text-diff',
    tags: ['diff', 'compare', 'text', 'changes']
  },
  {
    id: 'markdown-preview',
    name: 'Markdown Preview',
    description: 'Preview Markdown with live rendering and export options',
    category: 'text',
    icon: icons.markdownPreview,
    path: '/tools/markdown-preview',
    tags: ['markdown', 'preview', 'render', 'export']
  },
  {
    id: 'lorem-generator',
    name: 'Lorem Ipsum Generator',
    description: 'Generate placeholder text for your designs and layouts',
    category: 'generator',
    icon: icons.loremIpsum,
    path: '/tools/lorem-generator',
    tags: ['lorem', 'ipsum', 'placeholder', 'text']
  },
  {
    id: 'minifier',
    name: 'Code Minifier',
    description: 'Minify HTML, CSS, and JavaScript code',
    category: 'formatter',
    icon: icons.minifier,
    path: '/tools/minifier',
    tags: ['minify', 'compress', 'html', 'css', 'javascript']
  },
  {
    id: 'beautifier',
    name: 'Code Beautifier',
    description: 'Format and beautify HTML, CSS, and JavaScript code',
    category: 'formatter',
    icon: icons.beautifier,
    path: '/tools/beautifier',
    tags: ['beautify', 'format', 'html', 'css', 'javascript']
  },
  {
    id: 'timestamp-converter',
    name: 'Timestamp Converter',
    description: 'Convert between Unix timestamps and human-readable dates',
    category: 'converter',
    icon: icons.timestampConverter,
    path: '/tools/timestamp-converter',
    tags: ['timestamp', 'unix', 'date', 'time', 'convert']
  },
  {
    id: 'unit-converter',
    name: 'Unit Converter',
    description: 'Convert between different units of measurement',
    category: 'converter',
    icon: icons.unitConverter,
    path: '/tools/unit-converter',
    tags: ['unit', 'convert', 'measurement', 'length', 'weight']
  },
  {
    id: 'csv-json-converter',
    name: 'CSV to JSON Converter',
    description: 'Convert CSV data to JSON format and vice versa',
    category: 'converter',
    icon: icons.csvJson,
    path: '/tools/csv-json-converter',
    tags: ['csv', 'json', 'convert', 'data']
  },
  {
    id: 'xml-json-converter',
    name: 'XML to JSON Converter',
    description: 'Convert XML data to JSON format and vice versa',
    category: 'converter',
    icon: icons.xmlJson,
    path: '/tools/xml-json-converter',
    tags: ['xml', 'json', 'convert', 'data']
  },
  {
    id: 'image-base64',
    name: 'Image to Base64',
    description: 'Convert images to Base64 strings and vice versa',
    category: 'converter',
    icon: icons.imageBase64,
    path: '/tools/image-base64',
    tags: ['image', 'base64', 'convert', 'encode']
  },
  {
    id: 'css-box-shadow',
    name: 'CSS Box Shadow Generator',
    description: 'Generate CSS box-shadow with live preview',
    category: 'generator',
    icon: '📦',
    path: '/tools/css-box-shadow',
    tags: ['css', 'box-shadow', 'generator', 'design']
  },
  {
    id: 'border-radius',
    name: 'Border Radius Generator',
    description: 'Generate CSS border-radius with visual editor',
    category: 'generator',
    icon: icons.borderRadius,
    path: '/tools/border-radius',
    tags: ['css', 'border-radius', 'generator', 'design']
  },
  {
    id: 'user-agent-parser',
    name: 'User Agent Parser',
    description: 'Parse and analyze user agent strings',
    category: 'network',
    icon: icons.userAgentParser,
    path: '/tools/user-agent-parser',
    tags: ['user-agent', 'parse', 'browser', 'device']
  },
  {
    id: 'http-status-codes',
    name: 'HTTP Status Codes',
    description: 'Reference for HTTP status codes with descriptions',
    category: 'network',
    icon: '📡',
    path: '/tools/http-status-codes',
    tags: ['http', 'status', 'codes', 'reference']
  },
  {
    id: 'mime-type-checker',
    name: 'MIME Type Checker',
    description: 'Look up MIME types for file extensions',
    category: 'network',
    icon: icons.mimeTypeChecker,
    path: '/tools/mime-type-checker',
    tags: ['mime', 'type', 'file', 'extension']
  },
  {
    id: 'string-escape',
    name: 'String Escape/Unescape',
    description: 'Escape and unescape strings for various programming languages',
    category: 'text',
    icon: '🔤',
    path: '/tools/string-escape',
    tags: ['string', 'escape', 'unescape', 'programming']
  }
];

export const featuredTools = tools.filter(tool => tool.featured);

export const categories = [
  { id: 'formatter', name: 'Formatters', icon: icons.colorPicker },
  { id: 'encoder', name: 'Encoders', icon: '🔐' },
  { id: 'generator', name: 'Generators', icon: '⚡' },
  { id: 'converter', name: 'Converters', icon: icons.textDiff },
  { id: 'validator', name: 'Validators', icon: '✅' },
  { id: 'text', name: 'Text Tools', icon: icons.markdownPreview },
  { id: 'color', name: 'Color Tools', icon: icons.gradient },
  { id: 'network', name: 'Network Tools', icon: icons.userAgentParser }
];